import isVariableGlobalsAvailable from './is-variable-globals-available';

export default {
  isVariableGlobalsAvailable,
};
